export const TOGGLE_DOMAIN_CHANGE_MODAL = 'TOGGLE_DOMAIN_CHANGE_MODAL';

export const toggleDomainChangeModal = () => ({
  type: TOGGLE_DOMAIN_CHANGE_MODAL,
});
